/* eslint func-style: "off" */

import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';
import { FETCH_NOTIFICATIONS, UPDATE_READ_FLAG,
  fetchNotificationsSucceeded, fetchNotificationsFailed, joinNotificationRoom,
} from './Notification.ducks';
import apiClient from 'helpers/apiClient';
import { SOCKET_RECONNECT } from 'actions';


// selectors
export const getUserId = (state) => state.AppUser.user.id;
export const getOffset = (state) => state.Notification.notifications.length;


// tasks
export const fetchNotifications = function* (action) {
  try {
    const userId = action.userId;
    const offset = yield select(getOffset);
    const payload = yield call(apiClient, `/api/users/${userId}/notifications?limit=20&offset=${offset}`);
    yield put(fetchNotificationsSucceeded(payload));
  } catch (e) {
    yield put(fetchNotificationsFailed(e.message));
  }
};

export const updateUserReadAt = function* (action) {
  const userId = action.userId;
  yield call(apiClient, `/api/users/${userId}/notifications/read`, {method: 'PUT'});
};

export const reconnectNotificationRoom = function* () {
  const userId = yield select(getUserId);
  yield put(joinNotificationRoom(userId));
};


// sagas
export const fetchNotificationsSaga = function* () {
  yield takeLatest( FETCH_NOTIFICATIONS, fetchNotifications);
};

export const updateUserReadAtSaga = function* () {
  yield takeLatest( UPDATE_READ_FLAG, updateUserReadAt);
};

export const socketReconnectSaga = function* () {
  yield takeLatest( SOCKET_RECONNECT, reconnectNotificationRoom);
};

const sagas = function* () {
  yield all([
    fork(fetchNotificationsSaga),
    fork(updateUserReadAtSaga),
    fork(socketReconnectSaga)
  ]);
};

export default sagas;
